/* import __COLOCATED_TEMPLATE__ from './spend-preview.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();